var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    id: "icon-search-32",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search-32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)",
    fill: "#00427a",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.07 23.485L17 18.415 18.414 17l5.071 5.07zM1.984 9.5c0 4.145 3.371 7.516 7.516 7.516 4.144 0 7.516-3.371 7.516-7.516S13.644 1.984 9.5 1.984c-4.145 0-7.516 3.371-7.516 7.516zM0 9.5C0 4.262 4.262 0 9.5 0S19 4.262 19 9.5c0 5.239-4.262 9.5-9.5 9.5S0 14.739 0 9.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2861832a0d5fff05d162c91a0fe81175.svg";
export { ForwardRef as ReactComponent };